import css from './notify.module.scss';
import EfImg from 'elem/ui/ef-img';
import { useLang } from '@/i18n';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';

export default function NotifyModal({ data, callback }: any) {
    const { t } = useLang('rapid.OtherA');

    return (
        <div className={`notify-modal ${css.notify}`}>
            <div className="content">
                <svg className="close" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" onClick={callback}>
                    <g clipPath="url(#clip0_4914_15771)">
                        <circle cx="10" cy="10" r="10" fill="#919191" />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.4379 14.4377C14.2659 14.6097 14.1001 14.7387 13.9404 14.8247C13.7807 14.9107 13.6108 14.8636 13.4306 14.6834L10 11.2528L6.55711 14.6957C6.38513 14.8677 6.2193 14.9107 6.05961 14.8247C5.89991 14.7387 5.73408 14.6097 5.5621 14.4377C5.39012 14.2658 5.26114 14.0999 5.17515 13.9402C5.08916 13.7805 5.13215 13.6147 5.30413 13.4427L8.74702 9.99983L5.31641 6.56923C5.13625 6.38906 5.08916 6.21913 5.17515 6.05943C5.26114 5.89974 5.39012 5.73391 5.5621 5.56193C5.73408 5.38995 5.89991 5.26096 6.05961 5.17497C6.2193 5.08898 6.38923 5.13607 6.5694 5.31624L10 8.74685L13.4306 5.31624C13.6026 5.14426 13.7705 5.09922 13.9343 5.18112C14.098 5.26301 14.2659 5.38995 14.4379 5.56193C14.6099 5.73391 14.7368 5.90179 14.8187 6.06558C14.9006 6.22937 14.8556 6.39725 14.6836 6.56923L11.253 9.99983L14.6836 13.4304C14.8638 13.6106 14.9108 13.7805 14.8249 13.9402C14.7389 14.0999 14.6099 14.2658 14.4379 14.4377Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_4914_15771">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <div className="img-box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1730088199269/icon.png" />
                </div>
                <p className="title">
                    {t('open_title') ||
                        t.rich('title', {
                            blue: (tx: string) => <span className="blue">{tx}</span>,
                        })}
                </p>
                <EfEmarsysEmail {...data} />
            </div>
        </div>
    );
}
